import { Routes } from '@angular/router';
import { authGuard } from '@umss/shared/core';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () =>
      import('@umss/business/feature-shell').then((m) => m.shellRoutes)
  },

  {
    path: 'auth',
    loadChildren: () =>
      import('@umss/business/feature-auth').then((m) => m.routes)
  },

  // fallback
  { path: '**', redirectTo: 'dashboard' }
];
